import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Catalogs|Exams';

export type ExamCatalogLoc = 'CPExamCatalogFilterByGroupLabel';

export const cpExamCatalogLocs: LocDefs<ExamCatalogLoc> = {
	CPExamCatalogFilterByGroupLabel: {
		defaultValue: 'Filter by Group',
		displayPath: `${dpRoot}|Filter by Group Label`,
		description: 'Label for filter by group.',
		displayType: 'Label',
		feature: HubFeature.Exam,
		portal: 'CP',
	},
};

export const LOC_KEYS = MapLocKeys<ExamCatalogLoc>(cpExamCatalogLocs);
